"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'rag.file.indexing_error': '文件索引失败。请重试，如果问题持续存在，请联系技术支持。',
};
